<template>
  <div class="weui-form-preview" v-if="flag === true">
    <div class="weui-form-preview__hd">
      <div class="weui-form-preview__item">
        <p>采购资金详情</p>
      </div>
    </div>
    <div class="weui-form-preview__bd">
      <div class="weui-form-preview__item xx">
        <div class="l">申请单位：</div>
        <div class="r">{{ Info.Single_Company}}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">申请日期：</div>
        <div class="r">{{ Info.Single_Time }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">订单编号：</div>
        <div class="r">{{ Info.Case_ID }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">是否信息化类：</div>
        <div class="r">{{ Info.Is_Information }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">项目名称：</div>
        <div class="r">{{ Info.Purchase_Name }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">采购类别：</div>
        <div class="r">{{ Info.Purchase_Type }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">采购方式：</div>
        <div class="r">{{ Info.Purchase_Function }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">进口设备：</div>
        <div class="r">{{ Info.Purchase_Equipment }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">总价（元）：</div>
        <div class="r">{{ Info.Purchase_Sum }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">资金来源：</div>
        <div class="r">{{ Info.Purchase_source }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">审核金额（元）：</div>
        <div class="r">{{ Info.Purchase_amount }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">申请理由：</div>
        <div class="r">{{ Info.Purchase_Reason }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">备注：</div>
        <div class="r">{{ Info.Purchase_Ramerks }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">费用年度（资本）：</div>
        <div class="r">{{ Info.Purchase_Budget }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">填表人：</div>
        <div class="r">{{ Info.Purchase_Operator }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">联系电话：</div>
        <div class="r">{{ Info.Purchase_Telephone }}</div>
      </div>


      <div v-if="dyly === true">
      <div class="weui-form-preview__hd">
        <div class="weui-form-preview__item">
          <p>单一来源</p>
        </div>
      </div>


      <div class="weui-form-preview__item xx">
        <div class="l">项目联系人：</div>
        <div class="r">{{ Info.Single_Contact }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">联系电话：</div>
        <div class="r">{{ Info.Single_Telephone }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">项目供应商名称：</div>
        <div class="r">{{ Info.Single_Supplier }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">供应商联系人：</div>
        <div class="r">{{ Info.Single_SupplierOp }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">手机号码：</div>
        <div class="r">{{ Info.Single_Phone }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">预算金额（元）：</div>
        <div class="r">{{ Info.Single_Budget_Price }}</div>
      </div>
      <div class="weui-form-preview__item xx">
        <div class="l">询价金额（元）：</div>
        <div class="r">{{ Info.Single_Price }}</div>
      </div>
      </div>

      <div style="width: 100%;text-align: center">
        <h3>采购明细</h3>
        <div v-html="xsd">

        </div>
      </div>
      <ul id="app">
        <li v-for='(file, index) in Info.FileList'>
          <a style="font-weight: bold; color: rgb(122 122 122)">{{file.name}}</a>
          </br>
          <a style="color: #0a67fb" @click="handDown(file)">下载</a>
          &nbsp;&nbsp;&nbsp;
          <a style="color: #0a67fb"  @click="handlePreview(file)">预览</a>
        </li>
      </ul>
      <br/>
    </div>

    <div style="width: 100%">
      <template>
        <el-table
            :data="SpYj"
            style="width: 100%;">
          <el-table-column
              align="center"
              prop="Step_Name"
              label="审批步骤"
              width="200" style="background: #0d3d88">
          </el-table-column>
          <el-table-column
              align="center"
              prop="Status"
              label="状态"
              width="70">
          </el-table-column>
          <el-table-column
              align="center"
              prop="Abroad_Info"
              label="审批意见"
              width="200">
          </el-table-column>
          <el-table-column
              align="right"
              prop="Abroad_Op"
              label="审批人"
              width="70">
          </el-table-column>
          <el-table-column
              align="center"
              prop="create_time"
              label="审批时间"
              width="200">
          </el-table-column>
        </el-table>
      </template>
    </div>
  </div>
</template>

<script>
import {Emas} from "@/assets/js/Emas";
import {GetPurchaseInfo} from "@/api/purchase";
import {WordToPdf} from "@/api/xxsb";
import {ImagePreview, Toast} from "vant";

export default {
name: "purchaseInfo",
  data() {
    return {
      flag: true,
      Mst_ID: 0,
      token: '',
      Info: {},
      fileList:[],
      SpYj:[],
      filePath:'',
      xsd:'',
      dyly:false
    }
  },
  created() {
    this.Mst_ID = this.$route.query.Mst_ID
    this.token = sessionStorage.getItem("token");
    this.User_ID = sessionStorage.getItem("User_ID");
    this.fetchData()
    let Staff_Name = sessionStorage.getItem("Staff_Name");
    let DD_ID = sessionStorage.getItem("DD_ID");
    Emas(Staff_Name, DD_ID, "purchaseInfo", "采购详情", "yywjjoa.yy.gov.cn/purchaseInfo")
  },
  methods:{
    async fetchData(){
      const {data} = await GetPurchaseInfo({token: this.token, UserId: this.User_ID, MstId: this.Mst_ID})
      console.log(data)
      if (data.code === 200) {
        this.flag = true
        this.Info = data.data
        this.SpYj=data.data.SpYj
        this.xsd=data.data.xsd
        if (this.Info.Purchase_Function=="单一来源"){
          this.dyly=true
        }else {
          this.dyly=false
        }
      } else {
        this.flag = false
      }
    },
    async zpdf(fileType) {
      const {data} = await WordToPdf({filePath: this.filePath})

      console.log(data)
      console.log(data.code)
      if (data.code === 200) {
        console.log(fileType)
        switch (fileType) {
          case "doc":
            this.filePath =  this.filePath.replace('.doc', '.pdf')
            break;
          case "docx":
            this.filePath =  this.filePath.replace('.docx', '.pdf')
            break;
          case "xls":
            this.filePath =  this.filePath.replace('.xls', '.pdf')
            break;
          case "xlsx":
            this.filePath =  this.filePath.replace('.xlsx', '.pdf')
            break;
        }
        console.log(this.filePath)
        sessionStorage.setItem("xxsb_file_url", this.filePath);
        console.log(this.filePath)
        Toast.clear();
        await this.$router.push({
          path: 'xxsbView',
          query: {}
        })
      } else {

      }
    },

    handlePreview(file) {
      this.appDown();
      let fileType = file.name.substr(file.name.lastIndexOf('.') + 1)
      if (this.isApple){
        let t = new Date().getTime()
        let a = document.createElement('a')
        a.href = '/api/' + file.url + '?t=' + t
        a.click();
      }else {

        Toast.loading({
          duration: 0, // 持续展示 toast
          message: '正在加载...',
          forbidClick: true,
        });

        if (fileType.toLowerCase() === 'pdf') {
          sessionStorage.setItem("xxsb_file_url", file.url);
          Toast.clear();
          this.$router.push({
            path: 'xxsbView',
            query: {}
          })
        }else if (fileType.toLowerCase() === 'docx'){
          console.log(file.url);
          this.filePath=file.url
          this.zpdf(fileType)
        }else if (fileType.toLowerCase() === 'doc'){
          console.log(file.url);
          this.filePath=file.url
          this.zpdf(fileType)
        }else if (fileType.toLowerCase() === 'xls'||fileType.toLowerCase() === 'xlsx'){
          console.log(file.url);
          this.filePath=file.url
          this.zpdf(fileType)
          // sessionStorage.setItem("xxsb_file_url", file.url);
          // sessionStorage.setItem("xxsb_file_name", file.name);
          // this.$router.push({
          //   path: 'excelViews',
          //   query: {
          //     url:file.url
          //   }
          // })
        }else if (fileType.toLowerCase() === 'png'||fileType.toLowerCase() === 'jpg'||fileType.toLowerCase() === 'jepg'){
          Toast.clear();
          ImagePreview({
            images: [
              'api/'+ file.url
            ],
            closeable: true,
          });
        } else {
          Toast.clear();
          let t = new Date().getTime()
          let a = document.createElement('a')
          a.href = '/api/' + file.url + '?t=' + t
          a.click();
        }
      }
      //let fileName = file.name.substr(0, file.name.lastIndexOf('.'))
      //let fileType = file.name.substr(file.name.lastIndexOf('.') + 1)
      //downloadFiles.downloadFiles(file.url + '?t=' + t, fileName, fileType)
    },
    handDown(file){
      let t = new Date().getTime()
      let a = document.createElement('a')
      a.href = '/api/' + file.url + '?t=' + t
      a.click();
    },
    // 判断是安卓还是ios
    appDown() {
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      if(isiOS){
        this.isApple = true
      }else if(isAndroid){
        this.isApple = false
      }
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/jquery-weui.css";
@import "../../../assets/css/weui.min.css";
@import "../../../assets/css/demos.css";

.weui-form-preview__hd {
  text-align: center;
}
.xx{
  border-bottom: 1px #CCCCCC dashed !important;
}

.weui-form-preview__item .l{
  width: 40%;
  text-align: right;
  float: left;
 word-wrap:break-word !important;
}


.weui-form-preview__item .r{
  width: 60%;
  text-align: left;
  float: left;
  word-wrap:break-word !important;
}

.weui-cell {
  font-size: .9em;
}

/*项目进度CSS*/
.weui-form-preview {
  overflow: inherit;
}

.weui-cell {
  top: 0;
  position: sticky;
}

.middle table {
  background-color: #fff;
  padding-left: 3%;
  padding-right: 3%;
  font-size: 14px;
}

.middle table tr th {
  font-weight: normal;
  border-bottom: 1px solid #dcdcdc;
  border-top: 1px solid #dcdcdc;
  padding-top: 3%;
  padding-bottom: 3%;
  text-align: center;
}

.middle table tr th:first-child {

  text-align: left;
}

.middle table tr td {

  text-align: center;
}

.middle table tr td:first-child {

  text-align: left;
}

.weui-cell__bd span {
  color: #5288f5;
}

article h4,
h4 {
  top: 0;
  position: sticky;
}
</style>